export default __webpack_public_path__ + "static/media/group.0c79f68f.png";